<template>
    <div class="ainose-box">
        <template v-for="item in imgs">
            <div class="progressive">
                <img class="preview" v-progressive="item.src" :src="item.preview" v-if="aiNose==null"/>
                <img class="preview" v-progressive="aiNose.detailImage1" :src="item.preview" v-else/>
            </div>
        </template>
<!--        <img class="ainose-img" src="../../static/image/product/ainose/aiNose-header.png">-->
        <img class="ainose-img" v-lazy="aiNoseB01" v-if="aiNose==null">
        <img class="ainose-img" v-lazy="aiNose.detailImage2" v-else>
        <img class="ainose-img" v-lazy="aiNoseB02" v-if="aiNose==null">
        <img class="ainose-img" v-lazy="aiNose.detailImage3" v-else>
        <img class="ainose-img" v-lazy="aiNoseB03" v-if="aiNose==null">
        <img class="ainose-img" v-lazy="aiNose.detailImage4" v-else>
    </div>
</template>

<script>
import aiNoseHeader from "../../static/image/product/ainose/aiNose-header.jpg"
import aiNoseHeaderM from "../../static/image/product/ainose/aiNose-header-min.png"
import aiNoseB01 from "../../static/image/product/ainose/aiNose-B01.png"
import aiNoseB02 from "../../static/image/product/ainose/aiNose-B02.jpg"
import aiNoseB03 from "../../static/image/product/ainose/aiNose-B03.jpg"

export default {
  name: 'Ainose',
  metaInfo: {
    title: 'Ainose', // set a title
    meta: [{                 // set meta
      name: 'keyWords',
      content: 'Ainose'
    }],
    link: [{                 // set link
      rel: 'description',
      content: '这是索康的官网的Ainose'
    }]
  },
  created() {
    // 创建时执行跳转锚点位置
    this.$nextTick(() => {
      // console.log(findId)
      this.$store.dispatch('method/anchorPoint', 'header')
    })
    this.aiNose=this.$store.getters.aiNose
    // console.log(this.aiNose)
  },
  data(){
    return{
      imgs:[{
        src:aiNoseHeader,
        preview:aiNoseHeaderM
      }],
      aiNoseB01:aiNoseB01,
      aiNoseB02:aiNoseB02,
      aiNoseB03:aiNoseB03,
      aiNose:null
    }
  }
}
</script>

<style scoped>
    .ainose-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
    }

    .ainose-img {
        width: 100%;
    }
</style>
